module Client.Components.PasswordChange

open Client
open Client.Services
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.SweetAlert
open Feliz.UseElmish
open Fable.Core.Experimental
open Fable.Core.JS
open CustomerDexImaging.Models

let passwordChangeModal = React.functionComponent(fun (inputProps: {| isOpen: bool; onClose: unit -> unit; onSubmit: string -> unit |}) ->
  let (password, setPassword) = React.useState("")
  // Browser.Dom.console.log("change password modal initial state: ", sprintf "%A" inputProps.isOpen)
  Mui.dialog [
    dialog.open' inputProps.isOpen
    dialog.onClose (fun _ -> inputProps.onClose ())
    dialog.children [
      Mui.dialogTitle [
        dialogTitle.children "Change Password"
      ]
      Mui.dialogContent [
        Mui.textField [
          textField.label "New Password"
          textField.type' "password"
          textField.fullWidth true
          textField.value password
          // textField.onChange (fun e -> setPassword e.target?value)
        ]
      ]
      Mui.dialogActions [
        Mui.button [
          button.color.secondary
          // button.onClick (fun _ -> inputProps.onClose ())
          button.children "Cancel"
        ]
        Mui.button [
          button.color.primary
          // button.onClick (fun _ -> inputProps.onSubmit password)
          button.children "Submit"
        ]
      ]
    ]
  ]
)